import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Components
import ToolTableIcon from '../Images/ToolTableIcon';
import ToolChartIcon from '../Images/ToolChartIcon';
import ToolMapIcon from '../Images/ToolMapIcon';
// import ToolLineIcon from '../Images/ToolLineIcon';
import SidebarMapFiltersField from '../Admin2Map/SidebarMapFiltersType/SidebarMapFiltersField';

// Store
import { $toolSelected, setToolSelected } from '../../store/slices/admin2ToolsSlice';
import { $adminSelected } from '../../store/slices/sidebarMapFiltersSlice';

// Configs
import { ADMIN__5X5km, ADMIN__Admin2 } from '../../configs/map.configs';
import { TOOLS_OPTIONS_OBJECT, TOOLS_ICON_TITLE_PLACEHOLDER } from '../../configs/tools.configs';

// Styles
import './Admin2Tools.scss';

function Admin2Tools() {
  const toolSelected = useSelector($toolSelected);
  const adminSelected = useSelector($adminSelected);
  const dispatch = useDispatch();

  function handleToolSelected(toolSelected: string) {
    dispatch(setToolSelected(toolSelected));
  }

  return (
    <section className='row'>
      <div className='col-lg-12 col-md-12'>
        <div className='Admin2Tools'>
          <button className={'tool-button'} onClick={() => handleToolSelected(TOOLS_OPTIONS_OBJECT.map.label)}>
            <ToolMapIcon
              selected={TOOLS_OPTIONS_OBJECT.map.label === toolSelected}
              title={`${TOOLS_ICON_TITLE_PLACEHOLDER} Map`}
            />
          </button>

          {adminSelected !== ADMIN__5X5km && (
            <>
              <button className={'tool-button'} onClick={() => handleToolSelected(TOOLS_OPTIONS_OBJECT.table.label)}>
                <ToolTableIcon
                  selected={TOOLS_OPTIONS_OBJECT.table.label === toolSelected}
                  title={`${TOOLS_ICON_TITLE_PLACEHOLDER} Table`}
                />
              </button>
              <button className={'tool-button'} onClick={() => handleToolSelected(TOOLS_OPTIONS_OBJECT.chart.label)}>
                <ToolChartIcon
                  selected={TOOLS_OPTIONS_OBJECT.chart.label === toolSelected}
                  title={`${TOOLS_ICON_TITLE_PLACEHOLDER} Chart`}
                />
              </button>
            </>
          )}

          {TOOLS_OPTIONS_OBJECT.chart.label === toolSelected && adminSelected === ADMIN__Admin2 && (
            <SidebarMapFiltersField />
          )}

          {/*<button className={'tool-button'} onClick={() => handleToolSelected(TOOLS_OPTIONS_OBJECT.line.label)}>*/}
          {/*  <ToolLineIcon selected={TOOLS_OPTIONS_OBJECT.line.label === toolSelected} />*/}
          {/*</button>*/}
        </div>
      </div>
    </section>
  );
}

export default Admin2Tools;
